/**
 * Created by DejanK on 7/6/2017.
 *
 */

'use strict';

let lodash = require('lodash');

module.exports = TaxesFactory;

TaxesFactory.$inject = [];
function TaxesFactory(){

  let taxesConfig = { name: 'Taxes Breakdown', abbr: 'TX'};

  function TaxesSummary(taxesData, negotiation, negotiations){
    angular.merge(this, taxesData, taxesConfig);
    this.negotiation = negotiation;
    this.negotiations = negotiations;
  }

  TaxesSummary.prototype.getTaxes = getTaxes;

  TaxesSummary.prototype.getValue = function(){
    let taxes = {}, taxesArray = this.getTaxes();
    for(let i=0, il=taxesArray.length; i<il; i++){
      let tax = taxesArray[i], taxValue = this[tax.id];
      if(taxValue) {
        taxes[tax.id] = taxValue;
      }
    }
    return taxes;
  };

  TaxesSummary.prototype.getFormattedValue = function(tax){
    return tax.type === 'PERCENTAGE'
      ? this.negotiations.percentageFormatter.format(tax.value)
      : this.negotiations.currencyFormat.format(tax.value);
  };

  TaxesSummary.prototype.getFormattedValueById = function(taxId){
    let tax = this[taxId] || {};
    return tax.type === 'PERCENTAGE'
      ? this.negotiations.percentageFormatter.format(tax.value)
      : this.negotiations.currencyFormat.format(tax.value);
  };

  TaxesSummary.prototype.getFormattedAmountById = function(taxId){
    let tax = this[taxId] || {};
    return `(${this.negotiations.currencyFormat.format(tax.amount)})`;
  };

  TaxesSummary.prototype.isAvailable = function(taxId){
    let tax = this[taxId];
    return tax && tax.valid && tax.type !== 'UNAVAILABLE';
  };

  TaxesSummary.prototype.isIncluded = function(taxId){
    let tax = this[taxId];
    return tax && tax.included;
  };

  TaxesSummary.prototype.getFormattedTotal = function(){
    return this.getFormattedValue(this['total'] || {});
  };

  function getTaxes(){
    return [
      {id: 'lodging', name: 'Lodging Tax'},
      {id: 'state', name: 'State Tax'},
      {id: 'city', name: 'City Tax'},
      {id: 'vatGstRm', name: 'VAT/GST'},
      {id: 'vatGstFb', name: 'VAT/GST on food and beverage'},
      {id: 'service', name: 'Service Fee'},
      {id: 'occupancy', name: 'Occupancy Tax'},
      {id: 'other', name: 'Other Tax/Fee'}
    ];
  }

  return {
    create: (taxesData, negotiation, negotiations)=>{
      return new TaxesSummary(taxesData, negotiation, negotiations);
    },
    list: getTaxes
  }
}
